import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTopLevelState } from '../Slice/FundActions';

export const getTopLevelState = createAsyncThunk(
  'landingPage/topLevelState',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchTopLevelState();
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
